import "./Avatar.css";

/** Figma: Avatar/Image and Avatar/Initials, 32px, fully round.
 *  Sidebar client items use a 24px variant. */
export default function Avatar({
  name,
  src,
  size = 32,
}: {
  name: string;
  src?: string | null;
  size?: number;
}) {
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("");

  return src ? (
    <img
      className="avatar"
      src={src}
      alt=""
      style={{ width: size, height: size }}
    />
  ) : (
    <span
      className="avatar avatar--initials"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.34) }}
      aria-hidden="true"
    >
      {initials}
    </span>
  );
}
